import Q from 'q';
import api from '../../api';
import moment from 'moment-timezone';
import ACTION_TYPES from '../../constants/actionTypes';

/*
 * Start rental car extension
 * ========================================
 */

export function startRentalCarExtension(policyId, momentObj) {
  return {
    type: ACTION_TYPES.START_RENTAL_CAR_EXTENSION,
    payload: {
      dateStr: (momentObj && momentObj.toISOString()) || null,
      policyId,
    },
  };
}

/*
 * Get rental car extension policy
 * ========================================
 */

function getRentalCarExtensionPolicyRequest() {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_POLICY,
  };
}

function getRentalCarExtensionPolicySuccess(data) {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_POLICY_SUCCESS,
    payload: data,
  };
}

function getRentalCarExtensionPolicyFailure(error) {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_POLICY_FAILURE,
    error,
  };
}

export function getRentalCarExtensionPolicy() {
  return (dispatch, getState) => {
    const deferred = Q.defer();
    const { authToken, policiesById, rentalCarExtensionPolicyId } = getState();

    const policy = policiesById[rentalCarExtensionPolicyId];
    dispatch(getRentalCarExtensionPolicyRequest());

    api
      .getRentalCarExtensionPolicy({
        agreementId: policy.details.agreement.id,
        authToken,
      })
      .then(policy => {
        dispatch(getRentalCarExtensionPolicySuccess(policy));
        deferred.resolve(policy);
      })
      .catch(error => {
        dispatch(getRentalCarExtensionPolicyFailure(error));
        deferred.reject(error);
      });

    return deferred.promise;
  };
}

/*
 * Extension confirmation number
 * ========================================
 */

export function updateRentalCarExtensionConfirmationNumber(confirmationNumber) {
  return {
    type: ACTION_TYPES.UPDATE_RENTAL_CAR_EXTENSION_CONFIRMATION_NUMBER,
    payload: {
      confirmationNumber,
    },
  };
}

/*
 * Get rental car extension checkout
 * ========================================
 */

function getRentalCarExtensionCheckoutRequest(policy) {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT,
    payload: {
      policy,
    },
  };
}

function getRentalCarExtensionCheckoutSuccess(data) {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT_SUCCESS,
    payload: data,
  };
}

function getRentalCarExtensionCheckoutFailure(error) {
  return {
    type: ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT_FAILURE,
    error,
  };
}

export function getRentalCarExtensionCheckout() {
  return (dispatch, getState) => {
    const deferred = Q.defer();
    const {
      policiesById,
      rentalCarExtensionPolicyId,
      rentalCarExtensionPolicy,
      rentalCarExtensionReturnDate,
      authToken,
    } = getState();

    const policy = policiesById[rentalCarExtensionPolicyId];
    dispatch(getRentalCarExtensionCheckoutRequest(policy));

    api
      .getRentalCarExtensionCheckout({
        agreementId: policy.details.agreement.id,
        rentalAgreementNumber: rentalCarExtensionPolicy.rental_agreement_number,
        returnDate: moment(rentalCarExtensionReturnDate)
          .tz('UTC')
          .format('YYYY-MM-DD'),
        authToken,
      })
      .then(checkout => {
        dispatch(getRentalCarExtensionCheckoutSuccess(checkout));
        deferred.resolve(checkout);
      })
      .catch(error => {
        dispatch(getRentalCarExtensionCheckoutFailure(error));
        deferred.reject(error);
      });

    return deferred.promise;
  };
}

/*
 * Purchase extension
 * ========================================
 */

function startRentalCarExtensionPurchase() {
  return {
    type: ACTION_TYPES.PURCHASE_RENTAL_CAR_EXTENSION,
  };
}

function purchaseRentalCarExtensionSuccess(data) {
  return {
    type: ACTION_TYPES.PURCHASE_RENTAL_CAR_EXTENSION_SUCCESS,
    payload: data,
  };
}

function purchaseRentalCarExtensionError(error) {
  return {
    type: ACTION_TYPES.PURCHASE_RENTAL_CAR_EXTENSION_FAILURE,
    error,
  };
}

export function purchaseRentalCarExtension(cardElement) {
  return (dispatch, getState) => {
    const {
      account,
      rentalCarExtensionPolicyId,
      rentalCarExtensionPolicy,
      rentalCarExtensionReturnDate,
      rentalCarExtensionCheckout,
      rentalCarExtensionUID,
      policiesById,
      authToken,
    } = getState();

    const revenue = rentalCarExtensionCheckout.totals.grandtotal;
    const deferred = Q.defer();
    const policy = policiesById[rentalCarExtensionPolicyId];
    const opts = {
      agreementId: policy.details.agreement.id,
      rentalAgreementNumber: rentalCarExtensionPolicy.rental_agreement_number,
      returnDate: moment(rentalCarExtensionReturnDate)
        .tz('UTC')
        .format('YYYY-MM-DD'),
      firstName: account.firstName,
      lastName: account.lastName,
      email: account.email,
      uid: rentalCarExtensionUID,
      cardElement,
      revenue,
      authToken,
    };

    dispatch(startRentalCarExtensionPurchase());
    api
      .purchaseRentalCarExtension(opts)
      .then(purchaseData => {
        dispatch(purchaseRentalCarExtensionSuccess(purchaseData));
        deferred.resolve(purchaseData);
      })
      .catch(err => {
        dispatch(purchaseRentalCarExtensionError(err.response.body.error));
        deferred.reject(err.response.body.error);
      });

    return deferred.promise;
  };
}
